import React from 'react';
import Project from '../domain/Project';
import Link from '../ui/Link';
import ProjectCard from './ProjectCard';
import { TextLink } from '../ui';

export interface ProjectLinkProps {
  project: Project;
  variant?: 'plain' | 'card' | 'link';
  children?: React.ReactNode;
}

const ProjectLink: React.FC<ProjectLinkProps> = ({
  project,
  variant,
  children = project.name,
}) => {
  if (variant === 'card') {
    return <ProjectCard project={project} />;
  }

  const path = `/projects/view/${project.id}`;

  if (variant === 'link') {
    return <TextLink to={path}>{children}</TextLink>;
  }

  return <Link to={path}>{children}</Link>;
};

ProjectLink.defaultProps = {
  variant: 'plain',
};

export default ProjectLink;
